import React from "react";
import { Button } from "reactstrap";

export default function CommandButtons({
  getReport,
  getSchedulesCountReport,
}) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "center",
        marginBottom: 10,
        gap: 10,
        flexWrap: "wrap",
      }}
    >
      <Button
        color="success"
        className="waves-effect waves-light"
        style={{ display: "flex", alignItems: "center", gap: 6 }}
        onClick={getReport}
      >
        <i className="fas fa-file-excel" />
        Extrair Relatório
      </Button>
      <Button
        color="primary"
        className="waves-effect waves-light"
        style={{ display: "flex", alignItems: "center", gap: 6 }}
        onClick={getSchedulesCountReport}
      >
        <i className="fas fa-table" />
        Contagem por Programação
      </Button>
    </div>
  );
}
